import useTheme from '../../context/ThemeContext';

const variantClasses = {
  primary:   'bg-primary text-white hover:bg-primary-dark',
  secondary: 'bg-secondary text-white hover:opacity-90',
  ghost:     'border border-gray-200 text-secondary hover:bg-gray-50',
  outline:   'border-2 border-primary text-primary hover:bg-primary-light',
  danger:    'bg-red-600 text-white hover:bg-red-700',
  // Premium design-system pills (rounded-full here since the shared base is rounded-xl)
  ghostPremium: 'bg-card text-secondary border border-divider hover:bg-secondary hover:text-card hover:border-secondary rounded-full',
};

function Button({ children, variant = 'primary', fullWidth = false, loading = false, className = '', ...props }) {
  const currentTheme = useTheme()?.currentTheme;
  // Inverted primary-action pill: RED in dark, BLACK (cream text) in light.
  const invertedClass = currentTheme === 'dark'
    ? 'bg-primary text-white hover:bg-primary-dark rounded-full'
    : 'bg-secondary text-card hover:opacity-90 rounded-full';
  const variantClass = variant === 'inverted' ? invertedClass : variantClasses[variant];
  return (
    <button
      className={`
        inline-flex items-center justify-center gap-2
        font-semibold rounded-xl text-sm py-3 px-5
        transition-all disabled:opacity-60 disabled:cursor-not-allowed
        ${variantClass}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading && (
        <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
      )}
      {children}
    </button>
  );
}

export default Button;
